import React from "react";

export function BPawnIcon({ color = "#5F5955" }: { color?: string }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="28 34 134 142"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46 168.2C46.1 147 57.04 142.5 65.76 136.47C71.5 132.5 80.56 124.54 83.2 104.9H106.4C109.65 124.55 118.58 134.93 125.3 138.47C133.7 143.4 142.6 148 142.7 168.2H46Z"
        fill={color}
        stroke="#1A1A1A"
        strokeWidth="7"
        strokeLinejoin="round"
      />
      <path
        d="M94.99 50.2C101.01 50.2 106.17 52.21 110.49 56.14C114.89 60 117.12 64.66 117.2 70.2C117.12 75.58 114.89 80.24 110.49 84.09C106.95 87.39 102.78 89.4 98.07 90.12C96.38 89.96 94.6 90.04 92.75 90.2C87.66 89.72 83.26 87.63 79.56 84.09C75.16 80.16 73 75.58 73 70.2C73 64.82 75.16 60 79.56 56.14C83.8 52.12 88.97 50.2 94.99 50.2Z"
        fill={color}
        stroke="#1A1A1A"
        strokeWidth="7"
        strokeLinejoin="round"
      />
      <path
        d="M64 104.44V101.75C75.56 94.84 82.44 90.98 92.96 90.28C94.74 89.93 96.44 89.93 98.07 90.16C109.49 90.28 116.11 95.54 126 101.75V104.44C102.75 106.52 89.53 106.52 64 104.44Z"
        fill={color}
        stroke="#1A1A1A"
        strokeWidth="7"
        strokeLinejoin="round"
      />
    </svg>
  );
}
